import React, {FC} from 'react'
import {Modal} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {makeStyles} from "@material-ui/core/styles";
import {styles} from "../../../styles";
import {StyledButton} from "../../buttons";
import typesButton from "../../../Helpers/constants/typesStyledButton.costants";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const useStyles = makeStyles((theme) => (
    {
        modal: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            marginTop: 100,
            marginRight: '15%',
            marginLeft: '45%',
            zIndex: '99 !important',

            '& > div': {
                '&:first-child': {
                    backgroundColor: 'rgba(241,245,250,0.5) !important',
                    backdropFilter: 'blur(3px)',
                }
            },

            [theme.breakpoints.down('sm')]: {
                marginRight: '5%',
                marginLeft: '5%',
            },
        },
        modalWrapper: {
            backgroundColor: '#FFFFFF',
            boxSizing: 'border-box',
            maxWidth: 493,
            maxHeight: 550,
            overflowY: 'auto',
            width: '100%',
            borderRadius: 8,
            padding: 22,
            [theme.breakpoints.down('xs')]: {
                margin: 15,
                padding: 10,
            },
        },
        modalHead: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        modalCross: {
            color: styles.textColor,
            height: 24,
            width: 24,
            cursor: 'pointer',
        },
        modalContent: {
            padding: '0 26px 26px 34px',
            [theme.breakpoints.down('sm')]: {
                padding: '0 10px 10px 10px'
            }
        },
        modalName: {
            padding: '10px 0',
            fontSize: 21,
            fontWeight: 800,
            lineHeight: '29px',
            letterSpacing: '0.25px',
        },
        subtitle: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '23px',
            marginBottom: 15,
        },
        modalButtons: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        link: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: '220px',
            height: '48px',
            borderRadius: '4px',
            border: '1px solid #FFFFFF',
            transition: '300ms',
            cursor: "pointer",
            background: '#0073dd',
            color: '#FFFFFF',

            '&:hover': {
                border: '1px solid #0073dd',
                background: '#FFFFFF',
                color: '#0073dd',
            },

            [theme.breakpoints.down('sm')]: {
                width: '150px'
            },
        }
    }
));

type IProps = {
    hrefLink: string;
    handleSubmit: () => void;
    handleClose: () => void;
}

const ModalAddingToCalendar: FC<IProps> = ({
  hrefLink,
  handleSubmit,
  handleClose,
}) => {
    const classes: any = useStyles();

    return (
        <div>
                <Modal
                    open={true}
                    onClose={() => {}}
                    className={classes.modal}
                >
                    <div className={classes.modalWrapper}>
                        <div className={classes.modalHead}>
                            <CloseIcon
                                className={classes.modalCross}
                                onClick={handleClose}
                            />
                        </div>
                        <div className={classes.modalContent}>
                            <h4 className={classes.modalName}>
                                {'It\'s .ics file that you can use for native calendars'}
                            </h4>
                            <h6 className={classes.subtitle}>
                                {'Do you want download this file on your device ?'}
                            </h6>
                            <div className={classes.modalButtons}>
                                <StyledButton
                                    title={'Cancel'}
                                    style={{marginRight: '10px'}}
                                    type={typesButton.Secondary}
                                    handleClick={handleClose}
                                />
                                <a
                                    className={classes.link}
                                    href={hrefLink}
                                    download={`bookedAppointment_${new Date().toISOString()}.ics`}
                                    onClick={handleSubmit}
                                >
                                    Download
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal>
        </div>
    );
}

export default React.memo(ModalAddingToCalendar);